<template>
    <v-layout>
        <v-dialog v-model="isShowDialog" max-width="60rem" max-height="40%" persistent scrollable>
            <v-card>
                <v-card-title class="secondary elevation-4 white--text">
                    <div class="text-h5">
                        {{ title }}
                    </div>
                </v-card-title>
                <v-card-text class="message pa-4">
                    <alert-error
                        ref="error-alert"
                        :value="fetchFileInfoError || downloadError"
                        :title="errorTitle"
                        :details="errorDetails"
                        class="mr-2 ml-2"
                    />
                    <v-layout v-if="!fetchFileInfoError" class="pa-2">
                        <v-spacer />
                        <v-flex xs3 class="text-body-2 pl-0">
                            <label>{{ $t('REC_Report_File') }}</label>
                        </v-flex>
                        <v-flex xs8>
                            <v-flex xs12>
                                <file-items
                                    v-model="recFileItems"
                                    :disabled="disabled || isProcessing"
                                    is-right
                                    @copy-text="copyText"
                                />
                            </v-flex>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-divider />
                <v-card-actions class="pa-3 pr-6">
                    <v-spacer />
                    <button-app-control
                        ref="cancel-btn"
                        :disabled="disabled || isProcessing"
                        :label="$t('Close')"
                        text
                        @click="closeDialog()"
                    />
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { State, Action, Getter } from 'vuex-class';
import type { ErrorDetail } from '../../../../store/types';
import { AlertError, ButtonAppControl, FileItems } from '../../../atoms';
import ApiUrl from '../../../../api/url';
import type { PrivilegeIdLendingRecordState } from '../../../../store/modules/privilege_id_lending_record/types';
import type { LoginRecordState } from '../../../../store/modules/login_record/types';

@Component({
    name: 'TheLendingRecordRecFileDialog',
    components: {
        AlertError,
        ButtonAppControl,
        FileItems,
    },
})
export default class TheLendingRecordRecFileDialog extends Vue {
    @State('privilegeIdLendingRecord') state: PrivilegeIdLendingRecordState;
    @State('loginRecord') loginRecordState: LoginRecordState;
    @Prop({ default: undefined }) recFileItems: Array<string>;
    @Prop({ default: false }) readonly isShow: boolean;
    @Prop({ default: 0 }) readonly privilegeRecordId: number;
    @Prop({ default: '' }) readonly title: string;

    disabled: boolean = false;

    /**
     * getter, setter
     */
    get isShowDialog(): boolean {
        return this.isShow;
    }
    set isShowDialog(newVal: boolean) {
        this.$emit('update:is-show', newVal);
    }
    get isProcessing(): boolean {
        return this.state.recFileDownload.isProcessing;
    }
    get fetchFileInfoError(): boolean {
        return this.state.recFile.error || this.loginRecordState.recFile.error;
    }
    get downloadError(): boolean {
        return this.state.recFileDownload.error;
    }
    get errorTitle(): string {
        return (
            this.state.recFile.errorTitle ||
            this.loginRecordState.recFile.errorTitle ||
            this.state.recFileDownload.errorTitle
        );
    }
    get errorDetails(): Array<ErrorDetail> {
        return (
            this.state.recFile.errorDetails ||
            this.loginRecordState.recFile.errorDetails ||
            this.state.recFileDownload.errorDetails
        );
    }

    /**
     * methods
     */
    closeDialog(): void {
        this.isShowDialog = false;
    }
    copyText(text: string) {
        // フォーカスが移動してしまって選択が解除される場合があるので一旦disable
        this.disabled = true;

        // 仮想DOMの更新待ち
        (this as any).$nextTick(() => {
            const elm = document.createElement('div');
            elm.innerText = text;
            document.body.appendChild(elm);

            const selection = window.getSelection();
            const range = document.createRange();

            range.selectNodeContents(elm);
            selection.removeAllRanges();
            selection.addRange(range);

            document.execCommand('copy');

            selection.removeAllRanges();
            document.body.removeChild(elm);

            this.disabled = false;
        });
    }
}
</script>
